import type { Production } from '../types/production';

/**
 * Seed catalog.
 * - The first entry is Nicole's existing featured video. Its real title, synopsis,
 *   frame and video source must be filled in from the admin panel; nothing is invented.
 * - Every entry with `isDemo: true` is EXAMPLE content for demonstration only.
 */
export const seedProductions: Production[] = [
  {
    id: 'nicole-estreno-destacado',
    slug: 'primera-obra',
    title: 'Primera obra',
    synopsis: null,
    category: null,
    year: null,
    durationMinutes: null,
    posterUrl: null,
    videoUrl: null,
    status: 'published',
    releaseDate: null,
    isOriginal: true,
    isFeatured: true,
    collection: null,
    isDemo: false,
    createdAt: '2026-10-01T10:00:00.000Z',
  },
  {
    id: 'demo-ventanas',
    slug: 'demo-ventanas',
    title: 'Ventanas',
    synopsis:
      'Contenido de demostración. Una ciudad que nunca duerme y una mujer que la observa en silencio desde lo alto.',
    category: 'cortometraje',
    year: 2025,
    durationMinutes: 14,
    posterUrl:
      'https://cdn.magicpatterns.com/patterns/generated-images/6214f191-7520-4fd7-8ff6-5567312663c0.jpg',
    videoUrl: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
    status: 'published',
    releaseDate: null,
    isOriginal: true,
    isFeatured: false,
    collection: 'El universo de Nicole',
    isDemo: true,
    createdAt: '2026-09-12T10:00:00.000Z',
  },
  {
    id: 'demo-carretera-de-niebla',
    slug: 'demo-carretera-de-niebla',
    title: 'Carretera de niebla',
    synopsis:
      'Contenido de demostración. Un viaje al amanecer por una costa que parece borrarse a cada kilómetro.',
    category: 'pelicula',
    year: 2024,
    durationMinutes: 92,
    posterUrl:
      'https://cdn.magicpatterns.com/patterns/generated-images/4417f81a-51f6-47f3-b507-11904f9404b7.jpg',
    videoUrl: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
    status: 'published',
    releaseDate: null,
    isOriginal: true,
    isFeatured: false,
    collection: null,
    isDemo: true,
    createdAt: '2026-08-20T10:00:00.000Z',
  },
  {
    id: 'demo-archivo-16',
    slug: 'demo-archivo-16',
    title: 'Archivo 16',
    synopsis:
      'Contenido de demostración. Un recorrido por bobinas olvidadas y las historias que guardan entre fotogramas.',
    category: 'documental',
    year: 2025,
    durationMinutes: 28,
    posterUrl:
      'https://cdn.magicpatterns.com/patterns/generated-images/af383140-1e2c-46ea-bd52-58d429235ce5.jpg',
    videoUrl: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
    status: 'published',
    releaseDate: null,
    isOriginal: false,
    isFeatured: false,
    collection: 'El universo de Nicole',
    isDemo: true,
    createdAt: '2026-07-04T10:00:00.000Z',
  },
  {
    id: 'demo-un-solo-foco',
    slug: 'demo-un-solo-foco',
    title: 'Un solo foco',
    synopsis:
      'Contenido de demostración. Movimiento, polvo y luz en un escenario vacío.',
    category: 'experimental',
    year: 2026,
    durationMinutes: 9,
    posterUrl:
      'https://cdn.magicpatterns.com/patterns/generated-images/28dd1b55-8cd1-416e-902b-9fc93eaca15b.jpg',
    videoUrl: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
    status: 'published',
    releaseDate: null,
    isOriginal: true,
    isFeatured: false,
    collection: 'El universo de Nicole',
    isDemo: true,
    createdAt: '2026-06-15T10:00:00.000Z',
  },
  {
    id: 'demo-la-ultima-funcion',
    slug: 'demo-la-ultima-funcion',
    title: 'La última función',
    synopsis:
      'Contenido de demostración. Un teatro abandonado vuelve a encender su proyector una única noche.',
    category: 'pelicula',
    year: 2026,
    durationMinutes: null,
    posterUrl:
      'https://cdn.magicpatterns.com/patterns/generated-images/5b3d28ea-c6a5-4010-9c31-b6502f912dc9.jpg',
    videoUrl: null,
    status: 'scheduled',
    releaseDate: '2026-12-12',
    isOriginal: true,
    isFeatured: false,
    collection: null,
    isDemo: true,
    createdAt: '2026-09-30T10:00:00.000Z',
  },
];
